// htmlForBulkModal.js
import "./styles.scss";

export const htmlForBulkModal = (successCount, errorCount = []) => {
  return `
    <div class="bulk-modal">
      
      <!-- Success Section -->
      <div class="bulk-modal__success">
        
        <div class="bulk-modal__header">
          <div class="bulk-modal__icon bulk-modal__icon--success">
            ✓
          </div>

          <div class="bulk-modal__title">
            Bulk action completed successfully
          </div>
        </div>

        <div class="bulk-modal__content">
          ${successCount} records affected
        </div>

      </div>

      <!-- Error Section -->
      ${
        errorCount.length > 0
          ? `
        <div class="bulk-modal__errors">
          
          <div class="bulk-modal__header">
            <div class="bulk-modal__icon bulk-modal__icon--error">
              ✕
            </div>

            <div class="bulk-modal__title">
              Bulk action Errors:
            </div>
          </div>

          <div class="bulk-modal__content">
            ${errorCount
              .map(
                (record, index) => `
                  <div class="bulk-modal__error-item ${
                    index !== errorCount.length - 1
                      ? "bulk-modal__error-item--border"
                      : ""
                  }">
                    <div class="bulk-modal__text">
                      <strong>Title:</strong> ${record.title}
                    </div>

                    <div class="bulk-modal__text">
                      <strong>Error:</strong> ${record.error}
                    </div>
                  </div>
                `
              )
              .join("")}
          </div>

        </div>
      `
          : ""
      }

    </div>
  `;
};